import { waContentOf } from "./dataJson";

// Prévia de link: só com o que a própria mensagem do WhatsApp trouxe (título, descrição e
// miniatura). Nada é buscado na página de destino.

const text = (value, max) => (typeof value === "string" ? value.trim().slice(0, max) : "");

const safeUrl = (value) => {
  const raw = text(value, 2000);
  if (!raw) return null;
  const candidate = /^[a-z][a-z0-9+.-]*:/i.test(raw) ? raw : `https://${raw}`;
  if (!/^https?:\/\//i.test(candidate)) return null;
  try {
    const url = new URL(candidate);
    return { href: url.href, host: url.hostname.replace(/^www\./i, "") };
  } catch (e) {
    return null;
  }
};

const MAX_THUMB_BYTES = 300 * 1024;

// A miniatura pode vir em base64, como Buffer serializado ({type:"Buffer",data:[…]}),
// como lista de bytes ou como objeto {"0":255,"1":216,…} (Uint8Array que passou por JSON).
export const thumbnailToDataUrl = (value) => {
  try {
    if (!value) return null;
    if (typeof value === "string") {
      const clean = value.replace(/\s+/g, "");
      if (clean.length < 16 || clean.length > MAX_THUMB_BYTES * 1.4 || !/^[A-Za-z0-9+/_-]+=*$/.test(clean)) return null;
      return `data:image/jpeg;base64,${clean.replace(/-/g, "+").replace(/_/g, "/")}`;
    }
    let bytes = null;
    if (Array.isArray(value)) bytes = value;
    else if (typeof value === "object" && Array.isArray(value.data)) bytes = value.data;
    else if (typeof value === "object") {
      const keys = Object.keys(value);
      if (keys.length > 0 && keys.every((k) => /^\d+$/.test(k))) bytes = keys.sort((a, b) => a - b).map((k) => value[k]);
    }
    if (!bytes || bytes.length < 16 || bytes.length > MAX_THUMB_BYTES) return null;
    let binary = "";
    for (let i = 0; i < bytes.length; i += 1) {
      const byte = Number(bytes[i]);
      if (!Number.isInteger(byte) || byte < 0 || byte > 255) return null;
      binary += String.fromCharCode(byte);
    }
    return `data:image/jpeg;base64,${window.btoa(binary)}`;
  } catch (e) {
    return null;
  }
};

const cache = new WeakMap();

export const linkPreviewOf = (message) => {
  if (!message || typeof message !== "object") return null;
  if (cache.has(message)) return cache.get(message);
  let preview = null;
  try {
    const content = waContentOf(message);
    const ext = content && content.extendedTextMessage;
    if (ext && typeof ext === "object") {
      const url = safeUrl(ext.canonicalUrl) || safeUrl(ext.matchedText);
      const title = text(ext.title, 200);
      const description = text(ext.description, 400);
      if (url && (title || description)) {
        preview = { url: url.href, host: url.host, title, description, thumbnail: thumbnailToDataUrl(ext.jpegThumbnail) };
      }
    }
  } catch (e) {
    preview = null;
  }
  cache.set(message, preview);
  return preview;
};
